import React from "react";
const PageNotFound = () => {
    return React.createElement("p", null, "404");
};
export default PageNotFound;
